function injectSameDayShippingMsg() {
  const shippingMsg = $(".free_shipping_msg.apl-section-shipping");
  if (
    shippingMsg.length &&
    shippingMsg.is(":visible") &&
    !$(".same-day-delivery-note").length
  ) {
    const newMsg = `
      <p class="same-day-delivery-note" style="margin-top: 4px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
          <path d="M1.89353 9.84661C1.43772 9.84661 1.09151 9.72831 0.854906 9.49171C0.618302 9.2551 0.5 8.9089 0.5 8.45308V1.7464C0.5 1.28711 0.618302 0.939166 0.854906 0.702562C1.09151 0.465958 1.43772 0.347656 1.89353 0.347656H9.40919C9.865 0.347656 10.2112 0.467698 10.4478 0.707782C10.6844 0.947865 10.8027 1.29407 10.8027 1.7464V9.02198L10.1608 9.39776V1.75684C10.1608 1.50284 10.0946 1.31321 9.96242 1.18795C9.8302 1.05921 9.64057 0.994838 9.39353 0.994838H1.90397C1.65344 0.994838 1.46381 1.05921 1.33507 1.18795C1.20633 1.31321 1.14196 1.50284 1.14196 1.75684V8.43743C1.14196 8.69143 1.20633 8.8828 1.33507 9.01154C1.46381 9.14028 1.65344 9.20465 1.90397 9.20465H2.89562V9.84661H1.89353ZM10.4322 3.88628V3.24432H12.2902C12.5303 3.24432 12.7356 3.27737 12.9061 3.34348C13.08 3.40959 13.2383 3.51919 13.381 3.67229L15.1555 5.67647C15.2843 5.8226 15.373 5.967 15.4217 6.10966C15.4739 6.25232 15.5 6.43499 15.5 6.65768V8.45308C15.5 8.9089 15.3817 9.2551 15.1451 9.49171C14.9085 9.72831 14.5623 9.84661 14.1065 9.84661H13.3601V9.20465H14.0908C14.3413 9.20465 14.531 9.14028 14.6597 9.01154C14.7919 8.8828 14.858 8.69143 14.858 8.43743V6.64202C14.858 6.54111 14.8389 6.44021 14.8006 6.33931C14.7624 6.23492 14.7067 6.14098 14.6336 6.05747L12.9426 4.1629C12.8452 4.05503 12.7408 3.98196 12.6294 3.94369C12.5181 3.90542 12.3876 3.88628 12.238 3.88628H10.4322ZM11.7422 6.64202C11.6239 6.64202 11.5282 6.60722 11.4551 6.53764C11.3855 6.46805 11.3507 6.3741 11.3507 6.2558V4.41864H12.1284C12.2189 4.41864 12.2989 4.43777 12.3685 4.47605C12.4381 4.51084 12.5007 4.55782 12.5564 4.61697L14.1117 6.3654C14.15 6.40716 14.1795 6.44891 14.2004 6.49066C14.2248 6.53242 14.237 6.58287 14.237 6.64202H11.7422ZM4.27349 11.3341C3.95338 11.3341 3.6611 11.2558 3.39666 11.0992C3.1357 10.9426 2.92693 10.7321 2.77035 10.4677C2.61378 10.2067 2.53549 9.9162 2.53549 9.59609C2.53549 9.27598 2.61378 8.98544 2.77035 8.72448C2.92693 8.46004 3.1357 8.25128 3.39666 8.09818C3.6611 7.9416 3.95338 7.86331 4.27349 7.86331C4.5936 7.86331 4.88413 7.9416 5.14509 8.09818C5.40605 8.25128 5.61482 8.46004 5.7714 8.72448C5.92798 8.98544 6.00626 9.27598 6.00626 9.59609C6.00626 9.9162 5.92798 10.2067 5.7714 10.4677C5.61482 10.7321 5.40605 10.9426 5.14509 11.0992C4.88413 11.2558 4.5936 11.3341 4.27349 11.3341ZM4.27349 10.7756C4.48921 10.7756 4.6858 10.7217 4.86326 10.6138C5.04419 10.5095 5.18685 10.3668 5.29123 10.1859C5.39562 10.0084 5.44781 9.81182 5.44781 9.59609C5.44781 9.37688 5.39562 9.17855 5.29123 9.0011C5.18685 8.82365 5.04419 8.68273 4.86326 8.57835C4.6858 8.47048 4.48921 8.41655 4.27349 8.41655C4.05428 8.41655 3.85595 8.47048 3.6785 8.57835C3.50104 8.68273 3.35839 8.82365 3.25052 9.0011C3.14266 9.17855 3.08873 9.37688 3.08873 9.59609C3.08873 9.81182 3.14266 10.0084 3.25052 10.1859C3.35839 10.3668 3.50104 10.5095 3.6785 10.6138C3.85595 10.7217 4.05428 10.7756 4.27349 10.7756ZM11.8622 11.3341C11.5456 11.3341 11.255 11.2558 10.9906 11.0992C10.7262 10.9426 10.5157 10.7321 10.3591 10.4677C10.2025 10.2067 10.1242 9.9162 10.1242 9.59609C10.1242 9.27598 10.2025 8.98544 10.3591 8.72448C10.5157 8.46004 10.7262 8.25128 10.9906 8.09818C11.255 7.9416 11.5456 7.86331 11.8622 7.86331C12.1823 7.86331 12.4729 7.9416 12.7338 8.09818C12.9983 8.25128 13.207 8.46004 13.3601 8.72448C13.5167 8.98544 13.595 9.27598 13.595 9.59609C13.595 9.9162 13.5167 10.2067 13.3601 10.4677C13.207 10.7321 12.9983 10.9426 12.7338 11.0992C12.4729 11.2558 12.1823 11.3341 11.8622 11.3341ZM11.8622 10.7756C12.0814 10.7756 12.2797 10.7217 12.4572 10.6138C12.6347 10.5095 12.7756 10.3668 12.88 10.1859C12.9843 10.0084 13.0365 9.81182 13.0365 9.59609C13.0365 9.37688 12.9826 9.17855 12.8747 9.0011C12.7704 8.82365 12.6294 8.68273 12.452 8.57835C12.2745 8.47048 12.0779 8.41655 11.8622 8.41655C11.6465 8.41655 11.4499 8.47048 11.2724 8.57835C11.095 8.68273 10.9523 8.82365 10.8445 9.0011C10.7366 9.17855 10.6827 9.37688 10.6827 9.59609C10.6827 9.81182 10.7366 10.0084 10.8445 10.1859C10.9523 10.3668 11.095 10.5095 11.2724 10.6138C11.4499 10.7217 11.6465 10.7756 11.8622 10.7756ZM5.70355 9.84661V9.20465H10.4896V9.84661H5.70355Z" fill="black"></path>
        </svg>
        <b>Same Day Delivery :</b> Working Day Before 5pm<br>
        <small>*Exclude pre-order product</small>
      </p>`;
    shippingMsg.after(newMsg);
    // console.log("✅ Same-day shipping message injected");
  }
}

function movePickupSection() {
  const $pickup = $("#pickup_id");
  if ($pickup.length && !$pickup.closest(".pickup-extension-grid").length) {
    const $wrapper = $('<div class="pickup-extension-grid"></div>');
    $pickup.wrap($wrapper);
    $(".one-pickup").after($(".pickup-extension-grid"));
    // console.log("✅ Pickup section moved");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  injectSameDayShippingMsg();
  movePickupSection();

  const productInfoContainer = document.querySelector(".product__info-container");
  if (!productInfoContainer) return;

  const observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        injectSameDayShippingMsg();
        movePickupSection();
        break;
      }
    }
  });

  observer.observe(productInfoContainer, {
    childList: true,
    subtree: true,
  });
});





// $(document).ready(function () {
//   const shippingMsg = $(".free_shipping_msg.apl-section-shipping");
//   console.log("William Check");
//   // Check if the element exists and is *visible*
//   if (shippingMsg.length && shippingMsg.is(":visible")) {
//     const newMsg = `
//       <p class="same-day-delivery-note" style="margin-top: 4px;">
//         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
//           <path d="M1.89353 9.84661C1.43772 9.84661 1.09151 9.72831 0.854906 9.49171C0.618302 9.2551 0.5 8.9089 0.5 8.45308V1.7464C0.5 1.28711 0.618302 0.939166 0.854906 0.702562C1.09151 0.465958 1.43772 0.347656 1.89353 0.347656H9.40919C9.865 0.347656 10.2112 0.467698 10.4478 0.707782C10.6844 0.947865 10.8027 1.29407 10.8027 1.7464V9.02198L10.1608 9.39776V1.75684C10.1608 1.50284 10.0946 1.31321 9.96242 1.18795C9.8302 1.05921 9.64057 0.994838 9.39353 0.994838H1.90397C1.65344 0.994838 1.46381 1.05921 1.33507 1.18795C1.20633 1.31321 1.14196 1.50284 1.14196 1.75684V8.43743C1.14196 8.69143 1.20633 8.8828 1.33507 9.01154C1.46381 9.14028 1.65344 9.20465 1.90397 9.20465H2.89562V9.84661H1.89353ZM10.4322 3.88628V3.24432H12.2902C12.5303 3.24432 12.7356 3.27737 12.9061 3.34348C13.08 3.40959 13.2383 3.51919 13.381 3.67229L15.1555 5.67647C15.2843 5.8226 15.373 5.967 15.4217 6.10966C15.4739 6.25232 15.5 6.43499 15.5 6.65768V8.45308C15.5 8.9089 15.3817 9.2551 15.1451 9.49171C14.9085 9.72831 14.5623 9.84661 14.1065 9.84661H13.3601V9.20465H14.0908C14.3413 9.20465 14.531 9.14028 14.6597 9.01154C14.7919 8.8828 14.858 8.69143 14.858 8.43743V6.64202C14.858 6.54111 14.8389 6.44021 14.8006 6.33931C14.7624 6.23492 14.7067 6.14098 14.6336 6.05747L12.9426 4.1629C12.8452 4.05503 12.7408 3.98196 12.6294 3.94369C12.5181 3.90542 12.3876 3.88628 12.238 3.88628H10.4322ZM11.7422 6.64202C11.6239 6.64202 11.5282 6.60722 11.4551 6.53764C11.3855 6.46805 11.3507 6.3741 11.3507 6.2558V4.41864H12.1284C12.2189 4.41864 12.2989 4.43777 12.3685 4.47605C12.4381 4.51084 12.5007 4.55782 12.5564 4.61697L14.1117 6.3654C14.15 6.40716 14.1795 6.44891 14.2004 6.49066C14.2248 6.53242 14.237 6.58287 14.237 6.64202H11.7422ZM4.27349 11.3341C3.95338 11.3341 3.6611 11.2558 3.39666 11.0992C3.1357 10.9426 2.92693 10.7321 2.77035 10.4677C2.61378 10.2067 2.53549 9.9162 2.53549 9.59609C2.53549 9.27598 2.61378 8.98544 2.77035 8.72448C2.92693 8.46004 3.1357 8.25128 3.39666 8.09818C3.6611 7.9416 3.95338 7.86331 4.27349 7.86331C4.5936 7.86331 4.88413 7.9416 5.14509 8.09818C5.40605 8.25128 5.61482 8.46004 5.7714 8.72448C5.92798 8.98544 6.00626 9.27598 6.00626 9.59609C6.00626 9.9162 5.92798 10.2067 5.7714 10.4677C5.61482 10.7321 5.40605 10.9426 5.14509 11.0992C4.88413 11.2558 4.5936 11.3341 4.27349 11.3341ZM4.27349 10.7756C4.48921 10.7756 4.6858 10.7217 4.86326 10.6138C5.04419 10.5095 5.18685 10.3668 5.29123 10.1859C5.39562 10.0084 5.44781 9.81182 5.44781 9.59609C5.44781 9.37688 5.39562 9.17855 5.29123 9.0011C5.18685 8.82365 5.04419 8.68273 4.86326 8.57835C4.6858 8.47048 4.48921 8.41655 4.27349 8.41655C4.05428 8.41655 3.85595 8.47048 3.6785 8.57835C3.50104 8.68273 3.35839 8.82365 3.25052 9.0011C3.14266 9.17855 3.08873 9.37688 3.08873 9.59609C3.08873 9.81182 3.14266 10.0084 3.25052 10.1859C3.35839 10.3668 3.50104 10.5095 3.6785 10.6138C3.85595 10.7217 4.05428 10.7756 4.27349 10.7756ZM11.8622 11.3341C11.5456 11.3341 11.255 11.2558 10.9906 11.0992C10.7262 10.9426 10.5157 10.7321 10.3591 10.4677C10.2025 10.2067 10.1242 9.9162 10.1242 9.59609C10.1242 9.27598 10.2025 8.98544 10.3591 8.72448C10.5157 8.46004 10.7262 8.25128 10.9906 8.09818C11.255 7.9416 11.5456 7.86331 11.8622 7.86331C12.1823 7.86331 12.4729 7.9416 12.7338 8.09818C12.9983 8.25128 13.207 8.46004 13.3601 8.72448C13.5167 8.98544 13.595 9.27598 13.595 9.59609C13.595 9.9162 13.5167 10.2067 13.3601 10.4677C13.207 10.7321 12.9983 10.9426 12.7338 11.0992C12.4729 11.2558 12.1823 11.3341 11.8622 11.3341ZM11.8622 10.7756C12.0814 10.7756 12.2797 10.7217 12.4572 10.6138C12.6347 10.5095 12.7756 10.3668 12.88 10.1859C12.9843 10.0084 13.0365 9.81182 13.0365 9.59609C13.0365 9.37688 12.9826 9.17855 12.8747 9.0011C12.7704 8.82365 12.6294 8.68273 12.452 8.57835C12.2745 8.47048 12.0779 8.41655 11.8622 8.41655C11.6465 8.41655 11.4499 8.47048 11.2724 8.57835C11.095 8.68273 10.9523 8.82365 10.8445 9.0011C10.7366 9.17855 10.6827 9.37688 10.6827 9.59609C10.6827 9.81182 10.7366 10.0084 10.8445 10.1859C10.9523 10.3668 11.095 10.5095 11.2724 10.6138C11.4499 10.7217 11.6465 10.7756 11.8622 10.7756ZM5.70355 9.84661V9.20465H10.4896V9.84661H5.70355Z" fill="black"></path>
//         </svg>
//         <b>Shipping :</b> Working Day Before 4pm<br>
//         <small>*Exclude pre-order product</small>
//       </p>
//     `;
//     shippingMsg.after(newMsg);
//   }
// });


// $(document).ready(function () {
//   const $pickup = $('#pickup_id');

//   if ($pickup.length) {
//     // Wrap in a new container with proper class
//     const $wrapper = $('<div class="pickup-extension-grid"></div>');
//     $pickup.wrap($wrapper);

//     // Insert immediately after .one-pickup
//     $('.one-pickup').after($('.pickup-extension-grid'));
//   }
// });

//start sticky pickup availability
if (document.body.dataset.template === 'product') {
  // console.log("Product page detected. Overriding pickup-availability preview.");

  // start: sticky footer pickup-availability
  customElements.whenDefined('pickup-availability').then(() => {
    const PickupAvailability = customElements.get('pickup-availability');

    if (PickupAvailability?.prototype?.renderPreview) {
      PickupAvailability.prototype.renderPreview = function(location) {
        // console.log("Running custom renderPreview on product page");

        try {
          // Reference
          const itemKey = this.dataset.itemKey;
          const itemsAdded = parseInt(this.dataset.itemQuantity || '0', 10);

          // Replace location if item-specific match found
          if (itemKey && location) {
            const allItemLocations = this.storeLocator?.itemLocationsData?.[itemKey];
            if (Array.isArray(allItemLocations)) {
              const matched = allItemLocations.find(loc => loc?.id === location.id);
              if (matched) location = matched;
            }
          }

          this.info.innerHTML = '';
          const buttonText = location?.name || this.storeLocator?.dataset?.viewStoreAvailabilityText || 'View store availability';

          let availabilityHtml = '';
          let timeHtml = '';

          if (location) {
            this.dataset.quantityAvailable = location.quantityAvailable;
            
            // console.log("Location Available  -- "+location.quantityAvailable);

            const qty = Number(location.quantityAvailable);
            const message = this.preOrderMessageContainer?.innerHTML?.trim();

            // Availability Status Message
            if (location.available) {
              if (message) {
                const isReadyStock = message.toLowerCase() === "ready stock";
                timeHtml = `
                  <p class="caption">
                    <span class="pickup-availability__time" style="color:#0071e3">
                      ${message}${isReadyStock ? ". Get It Today!" : ""}
                    </span>
                  </p>
                `;
              } else {
                timeHtml = `
                  <p class="caption">
                    <span class="pickup-availability__time">Usually ready in 30 minutes*</span>
                  </p>
                `;
              }

              // Status badge
              const [statusClass, statusText] = qty === 0
                ? ['pickup-availability__sold-out', 'Sold Out']
                : qty <= 5
                  ? ['pickup-availability__limited', 'Limited']
                  : ['pickup-availability__available', 'Available'];

              // console.log("Quantity -- "+qty);

              availabilityHtml = `
                <p class="caption">
                  <span class="${statusClass}">${statusText}</span>
                </p>
              `;

              // If added quantity exceeds available
              if (itemsAdded > qty) {
                timeHtml = `
                  <p class="caption">
                    <span class="pickup-availability__error">${this.dataset.error}</span>
                  </p>
                `;
              }

            } else {
              // Not available case

              // start Convx : Ruby - #3243

              // availabilityHtml = `
              //   <p class="caption">
              //     <span style="color:#FF0000;">Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>
              //   </p>
              // `;
              const checkMsg = document.querySelector('.desktop-view_Product-title .product__preorder-message');
              if(checkMsg && checkMsg.textContent && checkMsg.textContent != 'Ready Stock'){
                availabilityHtml = `
                  <p class="caption">
                    <span style="color:#FF0000;">${checkMsg.textContent}</span>
                  </p>
                `;
              }else{
                availabilityHtml = `
                  <p class="caption">
                    <span style="color:#FF0000;">Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>
                  </p>
                `;
              }
              // end of #3243
            }
          }

          // Build preview content safely
          const html = `
            <div>
              ${availabilityHtml}
              ${timeHtml}
              <button
                class="js-my-store-locator-drawer-btn pickup-availability-button link link--text underlined-link"
                aria-haspopup="dialog"
                ${itemKey ? `data-item-key="${itemKey}"` : ''}
              >
                ${buttonText}
              </button>
            </div>
          `;

          const safeNode = new DOMParser().parseFromString(html, 'text/html').body.firstChild;
          if (safeNode) this.info.append(safeNode);

          // Attach store locator event
          const button = this.querySelector('button.js-my-store-locator-drawer-btn');
          if (button) {
            button.addEventListener('click', (evt) => {
              evt.preventDefault();
              this.storeLocatorDrawer.selectedItemLocationsKey = null;

              const selected = this.storeLocator?.itemLocationsData?.[itemKey];
              if (itemKey && selected) {
                this.storeLocatorDrawer.selectedItemLocationsKey = itemKey;
                this.storeLocatorDrawer.updateStoreDetails(selected, '');
              }

              this.storeLocatorDrawer.show(evt.currentTarget);
            });
          }
        } catch (err) {
          console.error('PickupAvailability renderPreview error:', err);
        }
      };
    }
  });
  // end 
}

// pickup right sticky drawer
document.addEventListener("DOMContentLoaded", function () {
  const drawerEl = document.querySelector("my-store-locator-drawer");
  if (!drawerEl) return;

  const originalUpdate = drawerEl.updateStoreDetails;

  drawerEl.updateStoreDetails = function (locationData, nearbyValue) {
    // Step 1: Pre-process each location
    locationData.forEach((location) => {
      const rawQty = location.quantityAvailable;
      const hasQty = typeof rawQty !== 'undefined' && rawQty !== null;
      const qty = hasQty ? parseInt(rawQty, 10) : null;

      let timeText = "";
      let stockText = "";
      // start Convx : Ruby - #3243
      const checkMsg = document.querySelector('.desktop-view_Product-title .product__preorder-message');
      // end of #3243

      if (!hasQty) {
        if (qty > 10) {
          timeText = "<span class='machines-stock-status status-ready'>Usually ready in 30 minutes**</span>";
          stockText = "<span class='machines-stock-label status-available'>Available</span>";
        } else {
          // start Convx : Ruby - #3243
          if(checkMsg && checkMsg.textContent && checkMsg.textContent != 'Ready Stock'){
            timeText = `<span class='machines-stock-status status-notready'>${checkMsg.textContent}</span>`;
          }else{
            timeText = "<span class='machines-stock-status status-notready'>Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>";
          }
          // timeText = "<span class='machines-stock-status status-notready'>Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>";
          // end of #3243

          stockText = "";
        }
      } else if (qty <= 0) {
        // start Convx : Ruby - #3243
        if(checkMsg && checkMsg.textContent && checkMsg.textContent != 'Ready Stock'){
          timeText = `<span class='machines-stock-status status-notready'>${checkMsg.textContent}</span>`;
        }else{
          timeText = "<span class='machines-stock-status status-notready'>Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>";
        }
        // timeText = "<span class='machines-stock-status status-notready'>Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>";
        // end of #3243
        
        stockText = "";
      } else if (qty > 0 && qty <= 5) {
        timeText = "<span class='machines-stock-status status-ready'>Usually ready in 30 minutes*</span>";
        stockText = "<span class='machines-stock-label status-limited'>Limited</span>";
      } else {
        timeText = "<span class='machines-stock-status status-ready'>Usually ready in 30 minutes*</span>";
        stockText = "<span class='machines-stock-label status-available'>Available</span>";
      }

      location.customAvailabilityTime = timeText;
      location.customAvailabilityStock = stockText;

      // console.log(`[DEBUG] Location: ${location.name}, rawQty: ${rawQty}, parsed qty: ${qty}, parsed hasQTY: ${hasQty}`);
    });

    // Step 2: Call original rendering method
    originalUpdate.call(this, locationData, nearbyValue);

    // Step 3: Patch rendered HTML
    this.querySelectorAll(".js-my-location-result").forEach((el) => {
      const id = el.dataset.id;
      const location = locationData.find((loc) => loc.id === id);
      if (!location) return;

      const availabilityWrapper = el.querySelector(".my-location-result__availability");

      // ✅ Clear availability section
      if (availabilityWrapper) {
        availabilityWrapper.innerHTML = "";
      }

      // Create and insert time element with span HTML
      const timeEl = document.createElement("div");
      timeEl.className = "my-location-result__availability-time";
      timeEl.innerHTML = location.customAvailabilityTime;
      availabilityWrapper?.appendChild(timeEl);

      // Create and insert stock element with span HTML
      const stockEl = document.createElement("div");
      stockEl.className = "my-location-result__availability-stock";
      stockEl.innerHTML = location.customAvailabilityStock || "";
      availabilityWrapper?.appendChild(stockEl);
    });
  };
});
//end

// pickup sticky right drawer : reduce location address
document.addEventListener("DOMContentLoaded", function () {
  const drawerEl = document.querySelector("my-store-locator-drawer");
  if (!drawerEl) return;

  const originalUpdate = drawerEl.updateStoreDetails;

  drawerEl.updateStoreDetails = function (locationData, nearbyValue) {
    originalUpdate.call(this, locationData, nearbyValue);

    // Patch address display after core renders
    this.querySelectorAll(".my-location-result__address").forEach((el) => {
      const anchor = el.querySelector("a[href^='http']");
      if (!anchor) return;

      // Try to extract and shorten address from original text
      const parts = anchor.textContent.split(",").map(s => s.trim());
      const newText = parts.slice(0, 4).join(", ");

      anchor.textContent = newText;
    });
  };
});

// end

document.addEventListener('DOMContentLoaded', function () {
  // Listen for tab button clicks
  document.querySelectorAll('.sdd-tab-buttons button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Remove "active" class from all buttons and tab contents
      document.querySelectorAll('.sdd-tab-buttons button').forEach(function(b){ b.classList.remove('active'); });
      document.querySelectorAll('.sdd-tab-content').forEach(function(tab){ tab.classList.remove('active'); });

      // Add "active" to this button and matching content
      btn.classList.add('active');
      var tabId = btn.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');
    });
  });
});

document.querySelectorAll('.accordion-header').forEach((header, idx, arr) => {
  header.addEventListener('click', function() {
    // If already open, do nothing
    if(header.classList.contains('active')) return;

    // Close all
    arr.forEach(h => {
      h.classList.remove('active');
      h.querySelector('.accordion-icon').textContent = '+';
    });
    document.querySelectorAll('.accordion-content').forEach(c => c.classList.remove('show'));

    // Open this one
    header.classList.add('active');
    header.querySelector('.accordion-icon').textContent = '-';
    header.nextElementSibling.classList.add('show');
  });
});
// On page load, open the first section
const firstHeader = document.querySelector('.accordion-header');
const firstContent = document.querySelector('.accordion-content');
if(firstHeader && firstContent) {
  firstHeader.classList.add('active');
  firstHeader.querySelector('.accordion-icon').textContent = '-';
  firstContent.classList.add('show');
}

// main cart
document.addEventListener("DOMContentLoaded", () => {
  const cartContainer = document.querySelector(".main-cart-items");
  if (!cartContainer) return;

  const observer = new MutationObserver(() => {
    cartContainer.querySelectorAll(".cart_itemadd").forEach(cartItem => {
      const stockEl = cartItem.querySelector(".pickup-availability__stock");
      const timeEl  = cartItem.querySelector(".pickup-availability__time");

      if (!stockEl || !timeEl) return;

      // Get raw qty before we overwrite the text
      let rawText = stockEl.textContent.trim();
      let qty = rawText.match(/\d+/) ? parseInt(rawText.replace(/\D/g, ""), 10) : NaN;

      // --- Stock label ---
      let stockLabel = "";
      if (isNaN(qty) || qty <= 0) {
        stockLabel = "";
      } else if (qty <= 5) {
        stockLabel = "Limited";
      } else {
        stockLabel = "Available";
      }

      // Replace "unavailable" with blank, otherwise use stockLabel
      if (/unavailable/i.test(rawText)) {
        stockEl.textContent = "";
      } else {
        stockEl.textContent = stockLabel;
      }

      // --- Time label ---
      let timeLabel = "";
      if (isNaN(qty) || qty <= 0) {
        timeLabel = "Usually ready in 2-4 working days<br>(Pre-orders follow batches)";
      } else {
        timeLabel = "Usually ready in 30 minutes*";
      }

      timeEl.textContent = timeLabel;
    });
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('DOMContentLoaded', function () {
  function initFeatureReadMore(scope = document) {
    const wraps = scope.querySelectorAll('.feature-value-wrap');

    wraps.forEach(function (wrap) {
      const content = wrap.querySelector('.feature-list-collapse');
      const button = wrap.querySelector('.feature-readmore-btn');

      if (!wrap || !content || !button) return;

      const items = content.querySelectorAll('ul li');

      /* reset state first */
      wrap.dataset.readmoreInit = 'true';
      content.classList.remove('is-collapsed');
      button.hidden = true;
      button.textContent = 'Read more';

      if (!items.length || items.length <= 3) {
        return;
      }

      content.classList.add('is-collapsed');
      button.hidden = false;

      /* avoid duplicate event binding */
      if (button.dataset.readmoreBound === 'true') return;
      button.dataset.readmoreBound = 'true';

      button.addEventListener('click', function () {
        const isCollapsed = content.classList.contains('is-collapsed');

        if (isCollapsed) {
          content.classList.remove('is-collapsed');
          button.textContent = 'Read less';
        } else {
          content.classList.add('is-collapsed');
          button.textContent = 'Read more';
        }
      });
    });
  }

  initFeatureReadMore();

  /* watch for variant/section HTML replacement */
  const observer = new MutationObserver(function (mutations) {
    let shouldInit = false;

    mutations.forEach(function (mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (
            node.matches?.('.feature-value-wrap, .js-features, .js-features-value') ||
            node.querySelector?.('.feature-value-wrap, .js-features, .js-features-value')
          ) {
            shouldInit = true;
          }
        });
      }
    });

    if (shouldInit) {
      initFeatureReadMore();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// --- Suppress Shopify customer privacy retry log ---
(function () {
  if (window.console && window.console.log) {
    const originalLog = console.log;
    console.log = function (...args) {
      if (args && args[0] && typeof args[0] === 'string' && args[0].includes('Shopify.customerPrivacy not yet available')) {
        // Suppress only that message
        return;
      }
      originalLog.apply(console, args);
    };
  }
})();















